<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar v-if="!openEmbedMode && !useMobileLayout" class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar v-if="!openEmbedMode"></navbar>
      <mobile-module-nav v-if="!openEmbedMode && useMobileLayout"></mobile-module-nav>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Navbar, Sidebar, AppMain } from './components'
import MobileModuleNav from './components/MobileModuleNav'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    MobileModuleNav
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters(['openEmbedMode', 'useMobileLayout']),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.useMobileLayout,
        openEmbedLayout: this.openEmbedMode
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>

<style rel="stylesheet/scss" lang="scss">
  #app .openEmbedLayout {
    .main-container {
      margin-left: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue